<template>
  <layout>
    <div class="row no-gutters justify-between">
      <h4>Edit company</h4>
      <h4 v-if="showStatusButtons">
        <button
          class="btn ml-2 btn-sm btn-success"
          @click="publishCompany">
          Publish and notify owner
        </button>
        <button
          class="btn ml-2 btn-sm btn-danger"
          @click="rejectCompany">
          Reject and notify owner
        </button>
      </h4>
    </div>
    <resource-form
      ref="form"
      :id="$route.params.id"
      @saved="returnBack"
      @cancelled="returnBack"
      @status:changed="onFormStatusChanged"
    />
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import ResourceForm from './Form.vue';

const resourceBase = 'companies';

const PUBLISHED = 'published';
const REJECTED = 'rejected';

export default {
  name: 'CompaniesEdit',

  components: {
    Layout,
    ResourceForm,
  },

  data() {
    return {
      showStatusButtons: false,
    }
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}.index` });
    },

    publishCompany() {
      this.notifyStatusChanged(PUBLISHED);
    },

    rejectCompany() {
      this.notifyStatusChanged(REJECTED);
    },

    notifyStatusChanged(status) {
      const promise = this.$http.post('/companies/notify-status-change', {
        company: this.$route.params.id,
        status,
      })
        .then(response => this.$refs.form.model = response.data.data)
        .catch(err => console.error(err));

      this.withUiBlocker(promise);
    },

    onFormStatusChanged(status) {
      this.showStatusButtons = (status === 'published' || status === 'rejected');
    }
  },

};
</script>
